<div class="row">
    <div class="col-sm-6">
        <h4>Lista de gráficos</h4>
    </div>
    <ng-container *ngIf="accessMP===true">
        <div class="col-sm-6 text-end">
            <a [routerLink]="['../../add', idtier3Selected]" class="btn-add">
                <i class="fa fa-plus px-2"></i> Agregar nuevo
            </a>
        </div>
    </ng-container>
</div>
<div class="row">
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-detail text-center table-success">
                <tr>
                    <th scope="col">N°</th>
                    <th scope="col">Tipo</th>
                    <th scope="col">Número</th>
                    <th scope="col">Título</th>
                    <th scope="col">Nota</th>
                    <th scope="col">Imágen</th>
                    <th scope="col">Orden</th>
                    <th scope="col">Estado</th>
                    <ng-container *ngIf="accessME===true">
                        <th scope="col"></th>
                    </ng-container>
                    <ng-container *ngIf="accessMD===true">
                        <th scope="col"></th>
                    </ng-container>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let o of graph; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ o.idgraphictype }}</td>
                    <td>{{ o.numeration }}</td>
                    <td>{{ o.title }}</td>
                    <td>{{ o.note }}</td>
                    <td>
                        <ng-container *ngIf="o.externalframe != null">
                            <pre>Frame DataWrapper</pre>
                        </ng-container>
                        <ng-container *ngIf="o.externalframe == null">
                            <ng-container *ngIf="o.urldata != null && o.urldata.substring(1,7)=='upload'">
                                <img class="img-fluid" src="{{URL}}{{o.urldata}}" alt="" style="max-height: 150px;">
                            </ng-container>
                            <ng-container *ngIf="o.urldata != null && o.urldata.substring(1,7)=='assets'">
                                <img class="img-fluid" src="{{o.urldata}}" alt="" style="max-height: 150px;">
                            </ng-container>
                        </ng-container>
                    </td>
                    <td class="text-center">{{ o.order }}</td>
                    <td class="text-center">
                        <div class="label-active" *ngIf="o.status">ACTIVO</div>
                        <div class="label-inactive" *ngIf="!o.status">INACTIVO</div>
                    </td>
                    <ng-container *ngIf="accessME===true">
                        <td class="text-center"><a class="a-icon" [routerLink]="['/adm/grafico/edit', o.id]"><i
                                    class="fa fa-pencil i-icon"></i></a></td>
                    </ng-container>
                    <ng-container *ngIf="accessMD===true && !isBlockedTier3">
                        <td class="text-center"><a class="a-icon" (click)="deleteGraphic(o.id, o.numeration)"><i
                                    class="fa fa-trash i-icon"></i></a></td>
                    </ng-container>
                </tr>
            </tbody>
        </table>
    </div>
</div>